import React from 'react';

interface GoalProgressBarProps {
  currentValue: number;
  targetValue: number;
  unit: string;
  progress?: number;
  showValues?: boolean;
  className?: string;
}

const GoalProgressBar: React.FC<GoalProgressBarProps> = ({
  currentValue,
  targetValue,
  unit,
  progress,
  showValues = true,
  className = '',
}) => {
  const calculatedProgress = progress !== undefined
    ? progress
    : targetValue > 0
    ? (currentValue / targetValue) * 100
    : 0;

  const progressColor =
    calculatedProgress >= 100
      ? 'bg-green-500'
      : calculatedProgress >= 50
      ? 'bg-blue-500'
      : 'bg-yellow-500';

  return (
    <div className={className}>
      {showValues && (
        <div className="flex items-center justify-between text-sm mb-1">
          <span className="text-gray-700">
            {currentValue} / {targetValue} {unit}
          </span>
          <span className="text-gray-600 font-medium">{Math.round(calculatedProgress)}%</span>
        </div>
      )}
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className={`h-2.5 rounded-full transition-all ${progressColor}`}
          style={{ width: `${Math.min(100, calculatedProgress)}%` }}
          role="progressbar"
          aria-valuenow={calculatedProgress}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
};

export default GoalProgressBar;

